import { Box } from '@apia/theme';
import { TIcon } from '.';
import { Icon } from './Icon';
import { justToFillTheRow } from './util';

export const IconWrapper = <P extends Record<string, unknown>>({
  icon,
  iconWidth,
  rowIndex,
  colIndex,
}: {
  icon: string | TIcon<P>;
  iconWidth: number;
  rowIndex: number;
  colIndex: number;
}) => {
  return icon === justToFillTheRow ? (
    <Box sx={{ width: `${iconWidth}px` }} className="fill__the__row" />
  ) : (
    <Icon
      rowIndex={rowIndex}
      colIndex={colIndex}
      width={iconWidth}
      {...(icon as TIcon<Record<string, unknown>>)}
    />
  );
};
